export default {
  app: {
    name: "កីឡាបុុក",
    full: "គំរូរដ្ឋបាលខាងក្រោយ",
    minimized: "BO"
  },
  no_records: "គ្មានកំណត់ត្រា",
  welcome: "សូមស្វាគមន៍ត្រឡប់មកវិញ, {user}!",
  login: "ចូលទៅកាន់គណនីរបស់អ្នក",
  login_success: "ចូលជោគជ័យ",
  relogin: "សូមចូលម្តងទៀតទៅកាន់គណនីរបស់អ្នក។",
  expired: "អ្នកត្រូវបានចេញពីប្រព័ន្ធ ដោយសារតែមានការចូលច្រើនលើគណនី!",
  denied: "ការអនុញ្ញាតត្រូវបានបដិសេធ!",
  success: "អ្នកបានបញ្ចប់ដោយជោគជ័យ!",
  select_date_range: "សូមជ្រើសរើសកាលបរិច្ឆេទ",
  permission_denied: "អ្នកមិនមានសិទ្ធិអនុវត្តសកម្មភាពនេះទេ!",
  search_by_id_name: "ស្វែងរកតាមលេខសម្គាល់ ឬឈ្មោះ",
  search_by_name: "ស្វែងរកតាមឈ្មោះ",
  close: "គណនីត្រូវបានបិទ។ សូមទាក់ទងអ្នកគ្រប់គ្រងរបស់អ្នក។",
  suspend: "គណនីត្រូវបានផ្អាក។ សូមទាក់ទងអ្នកគ្រប់គ្រងរបស់អ្នក។",
  suspend_alert1: "គណនីរបស់អ្នកត្រូវបានផ្លាស់ប្តូរទៅជា \"មើលបានតែប៉ុណ្ណោះ\"។",
  suspend_alert2: "សូមយោងទៅកាន់អ្នកលើ។",
  freeze: "គណនីត្រូវបានបង្កក។ សូមទាក់ទងអ្នកគ្រប់គ្រងរបស់អ្នក។",
  account_id_length_error: "ប្រវែងលេខសម្គាល់គណនីមិនត្រឹមត្រូវ",
  change_user_status_confirm: "តើអ្នកប្រាកដថាចង់ផ្លាស់ប្តូរទំរង់ស្ថានភាពគណនីមែនទេ?",
  delete_confirm: "តើអ្នកប្រាកដថាចង់លុប \"{name}\" មែនទេ?",
  update_account_status_confirm: "តើអ្នកប្រាកដថាចង់ធ្វើបច្ចុប្បន្នភាពស្ថានភាពគណនី?",
  update_account_status_cancel: "បច្ចុប្បន្នភាពស្ថានភាពគណនីបានបរាជ័យ។",
  update_account_status_success: "ស្ថានភាពគណនីបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ!",
  update_account_password_confirm: "តើអ្នកប្រាកដថាចង់ធ្វើបច្ចុប្បន្នភាពពាក្យសម្ងាត់គណនី?",
  update_account_password_cancel: "បច្ចុប្បន្នភាពពាក្យសម្ងាត់បានបរាជ័យ។",
  update_account_password_success: "ពាក្យសម្ងាត់បានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ!",
  update_account_security_confirm: "តើអ្នកប្រាកដថាចង់ធ្វើបច្ចុប្បន្នភាពសុវត្ថិភាពគណនី?",
  update_account_security_cancel: "បច្ចុប្បន្នភាពសុវត្ថិភាពបានបរាជ័យ។",
  update_account_security_success: "សុវត្ថិភាពគណនីបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ!",
  update_account_authority_confirm: "តើអ្នកប្រាកដថាចង់ធ្វើបច្ចុប្បន្នភាពសិទ្ធិក្នុងគណនី?",
  update_account_authority_cancel: "បច្ចុប្បន្នភាពសិទ្ធិក្នុងគណនីបានបរាជ័យ។",
  update_account_authority_success: "សិទ្ធិក្នុងគណនីបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ!",
  block_sub_account_confirm: "តើអ្នកប្រាកដថាចង់ទប់ស្កាត់គណនីរង?",
  block_sub_account_cancel: "ការទប់ស្កាត់គណនីរងបានបរាជ័យ។",
  block_sub_account_success: "គណនីរងត្រូវបានទប់ស្កាត់ដោយជោគជ័យ!",
  unblock_sub_account_confirm: "តើអ្នកប្រាកដថាចង់ដោះសោគណនីរង?",
  unblock_sub_account_cancel: "ការដោះសោគណនីរងបានបរាជ័យ។",
  unblock_sub_account_success: "គណនីរងបានដោះសោដោយជោគជ័យ!",
  successful_update_profile: "អ្នកបានធ្វើបច្ចុប្បន្នភាពព័ត៌មានផ្ទាល់ខ្លួនដោយជោគជ័យ។",
  successful_update_security: "អ្នកបានធ្វើបច្ចុប្បន្នភាពកូដសុវត្ថិភាពដោយជោគជ័យ។",
  successful_create_account: "អ្នកបានបង្កើតគណនីថ្មីដោយជោគជ័យ។",
  update_platform_settings_confirm: "តើអ្នកប្រាកដថាចង់ធ្វើបច្ចុប្បន្នភាពការកំណត់វេទិកា?",
  update_platform_settings_cancel: "បច្ចុប្បន្នភាពការកំណត់វេទិកាបានបរាជ័យ។",
  update_platform_settings_success: "ការកំណត់វេទិកាបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ!",
  reset_accumulate_win_confirm: "តើអ្នកប្រាកដថាចង់កំណត់ឡើងវិញនូវដែនកំណត់ឈ្នះសរុប?",
  reset_accumulate_win_cancel: "កំណត់ឡើងវិញដែនកំណត់ឈ្នះសរុបបានបរាជ័យ។",
  reset_accumulate_win_success: "ដែនកំណត់ឈ្នះសរុបបានកំណត់ឡើងវិញដោយជោគជ័យ!",
  parent_platform_disabled: "ការកំណត់វេទិការបស់អ្នកលើត្រូវបានបិទ។",
  copy_success: "ព័ត៌មានគណនីត្រូវបានចម្លងទៅកាន់ក្ដារចម្លង។",
  copy_failed: "កម្មវិធីរុករករបស់អ្នកមិនគាំទ្រការចម្លងទៅកាន់ក្ដារចម្លងទេ។",
  copy_all_upline: "ចម្លងកំណត់ HDP កីឡាបាល់ទាត់ទៅកាន់ប្រភេទកីឡាទាំងអស់",
  copy_all_account: "ចម្លង HDP គណនីបាល់ទាត់ទៅកាន់ប្រភេទកីឡាទាំងអស់",
  copy_all_remaining: "ចម្លង HDP នៅសល់បាល់ទាត់ទៅកាន់ប្រភេទកីឡាទាំងអស់",
  copy_all_min: "ចម្លង HDP អប្បបរមាបាល់ទាត់ទៅកាន់ប្រភេទកីឡាទាំងអស់",
  copy_all_min_bet: "ចម្លងអប្បបរមាបាល់ទាត់ទៅកាន់ប្រភេទកីឡាទាំងអស់",
  copy_all_max_bet: "ចម្លងអតិបរមាបាល់ទាត់ទៅកាន់ប្រភេទកីឡាទាំងអស់",
  copy_all_max_per_match: "ចម្លងអតិបរមាជាការភ្នាល់ក្នុងការប្រកួតបាល់ទាត់ទៅកាន់ប្រភេទកីឡាទាំងអស់",
  create_secondary_account_success: "គណនីរងបានបង្កើតដោយជោគជ័យ! សូមចូលប្រើឡើងវិញ។",
  first_sub_account_success: "គណនីរងបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ! សូមចូលប្រើឡើងវិញ។",
  update_account_commission_confirm: "តើអ្នកប្រាកដថាចង់ធ្វើបច្ចុប្បន្នភាពកម្រៃជើងសារ?",
  update_account_commission_cancel: "ការបច្ចុប្បន្នភាពកម្រៃជើងសារបានបរាជ័យ។",
  update_account_commission_success: "កម្រៃជើងសារបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ!",
  update_account_position_confirm: "តើអ្នកប្រាកដថាចង់ធ្វើបច្ចុប្បន្នភាពការទទួលការភ្នាល់?",
  update_account_position_cancel: "ការបច្ចុប្បន្នភាពការទទួលការភ្នាល់បានបរាជ័យ។",
  update_account_position_success: "ការទទួលការភ្នាល់បានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ!",
  update_account_bet_limit_confirm: "តើអ្នកប្រាកដថាចង់ធ្វើបច្ចុប្បន្នភាពដែនកំណត់ភ្នាល់?",
  update_account_bet_limit_cancel: "បច្ចុប្បន្នភាពដែនកំណត់ភ្នាល់បានបរាជ័យ។",
  update_account_bet_limit_success: "ដែនកំណត់ភ្នាល់បានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ!",
  update_account_profile_confirm: "តើអ្នកប្រាកដថាចង់ធ្វើបច្ចុប្បន្នភាពពត៌មានគណនី?",
  update_account_profile_cancel: "ការបច្ចុប្បន្នភាពគណនីបានបរាជ័យ។",
  update_account_profile_success: "ពត៌មានគណនីបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ!",
  create_new_account_confirm: "តើអ្នកប្រាកដថាចង់បង្កើតគណនីថ្មី?",
  create_new_account_cancel: "ការបង្កើតគណនីថ្មីបានបរាជ័យ។",
  create_new_account_success: "គណនីថ្មីបានបង្កើតដោយជោគជ័យ!",
  create_sub_account_confirm: "តើអ្នកប្រាកដថាចង់បង្កើតគណនីរង?",
  create_sub_account_cancel: "ការបង្កើតគណនីរងបានបរាជ័យ។",
  create_sub_account_success: "គណនីរងបានបង្កើតដោយជោគជ័យ!",
  update_sub_account_confirm: "តើអ្នកប្រាកដថាចង់ធ្វើបច្ចុប្បន្នភាពគណនីរង?",
  update_sub_account_cancel: "ការបច្ចុប្បន្នភាពគណនីរងបានបរាជ័យ។",
  update_sub_account_success: "គណនីរងបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ!",
  unblock_account_profile_confirm: "តើអ្នកប្រាកដថាចង់ដោះសោប្រវត្តិគណនី?",
  unblock_account_profile_cancel: "ការដោះសោប្រវត្តិគណនីបានបរាជ័យ។",
  unblock_account_profile_success: "ប្រវត្តិគណនីបានដោះសោដោយជោគជ័យ!",
  settlement_confirm: "តើអ្នកប្រាកដថាចង់ដំណើរការដល់ការបង់ប្រាក់?",
  settlement_cancel: "ការបង់ប្រាក់បានបរាជ័យ។",
  settlement_success: "ការបង់ប្រាក់បានដំណើរការដោយជោគជ័យ!",
  settlement_not_allowed: "ការបង់ប្រាក់មិនត្រូវបានអនុញ្ញាតថ្ងៃនេះទេ!",
  search_with_working_date: "ស្វែងរកដោយកាលបរិច្ឆេទធ្វើការ",
  system_error: "ប្រព័ន្ធមិនអាចដំណើរការសំណើរបស់អ្នកបានទេ។",
  invalid_password: "ឈ្មោះអ្នកប្រើ ឬ ពាក្យសម្ងាត់មិនត្រឹមត្រូវ។",
  invalid_account: "គណនីមិនត្រឹមត្រូវ។",
  block: "គណនីរបស់អ្នកត្រូវបានទប់ស្កាត់។",
  invalid_security_code: "កូដសុវត្ថិភាពមិនត្រឹមត្រូវ។",
  source_account_id_required: "ត្រូវការលេខសម្គាល់គណនី។",
  target_account_id_required: "ត្រូវការលេខសម្គាល់គណនីគោលដៅ។",
  account_id_required: "ត្រូវការលេខសម្គាល់គណនី។",
  sub_login_id_required: "ត្រូវការលេខសម្គាល់ចូល។",
  account_not_exists: "គណនីមិនត្រឹមត្រូវ។",
  profile_not_exists: "គណនីមិនត្រឹមត្រូវ។",
  account_inactive: "គណនីអសកម្ម។",
  not_blocked_account: "គណនីមានសុពលភាព។",
  password_required: "ត្រូវការពាក្យសម្ងាត់។",
  parent_id_required: "ត្រូវការលេខសម្គាល់អ្នកលើ។",
  parent_not_exists:"គណនីមិនត្រឹមត្រូវ។",
  invalid_account_type: "ប្រភេទគណនីមិនត្រឹមត្រូវ។",
  account_exists: "គណនីមានរួចហើយ។",
  login_id_required: "ត្រូវការលេខសម្គាល់ចូល។",
  new_login_id_required: "ត្រូវការលេខសម្គាល់ចូលថ្មី។",
  login_id_not_exists: "លេខសម្គាល់ចូលមិនត្រឹមត្រូវ។",
  invalid_authority_role: "តួនាទីមិនត្រឹមត្រូវ។",
  profile_inactive: "ប្រវត្តិគណនីមិនត្រឹមត្រូវ។",
  secondary_account_exists: "គណនីរងមានរួចហើយ។",
  new_login_id_exists: "លេខសម្គាល់ចូលថ្មីមានរួចហើយ។",
  new_password_required: "ត្រូវការពាក្យសម្ងាត់ថ្មី។",
  security_tag_required: "ត្រូវការស្លាកសុវត្ថិភាព។",
  security_code_required: "ត្រូវការកូដសុវត្ថិភាព។",
  start_date_required: "ត្រូវការកាលបរិច្ឆេទចាប់ផ្តើម។",
  end_date_required: "ត្រូវការកាលបរិច្ឆេទបញ្ចប់។",
  start_date_gt_end_date: "កាលបរិច្ឆេទចាប់ផ្តើមធំប៉ុន្មានជាងកាលបរិច្ឆេទបញ្ចប់។",
  start_date_greater_end_date: "កាលបរិច្ឆេទចាប់ផ្តើមធំប៉ុន្មានជាងកាលបរិច្ឆេទបញ្ចប់។",
  member_id_required: "ត្រូវការលេខសម្គាល់សមាជិក។",
  currency_code_required: "ត្រូវការកូដរូបិយប័ណ្ណ។",
  commission_setting_not_exists: "ការកំណត់កម្រៃជើងសារមិនមានទេ។",
  incomplete_account_line: "បន្ទាត់គណនីមិនបានបញ្ចប់។",
  invalid_hdp_package: "កញ្ចប់ HDP មិនត្រឹមត្រូវ។",
  search_id_required: "ត្រូវការលេខសម្គាល់ស្វែងរក។",
  profile_id_required: "ត្រូវការលេខសម្គាល់ប្រវត្តិគណនី។",
  login_not_exists: "លេខសម្គាល់ចូលមិនត្រឹមត្រូវ។",
  no_changes: "គ្មានការផ្លាស់ប្តូរត្រូវបានរកឃើញ។",
  start_date_require: "ត្រូវការកាលបរិច្ឆេទចាប់ផ្តើម។",
  league_id_required: "ត្រូវការលេខសម្គាល់លីគ។",
  sport_type_required: "ត្រូវការប្រភេទកីឡា។",
  match_id_required: "ត្រូវការលេខសម្គាល់ការប្រកួត។",
  target_login_id_required: "ត្រូវការលេខសម្គាល់ចូលគោលដៅ។",
  parent_account_not_exists: "គណនីមិនត្រឹមត្រូវ។",
  parent_account_inactive: "គណនីឪពុក/ម្ដាយអសកម្ម។",
  parent_profile_not_exists: "គណនីមិនត្រឹមត្រូវ។",
  parent_profile_inactive: "ប្រវត្តិឪពុក/ម្ដាយអសកម្ម។",
  target_login_id_not_exists: "គណនីគោលដៅមិនត្រឹមត្រូវ។",
  incorrect_parent: "លេខសម្គាល់ឪពុក/ម្ដាយមិនត្រឹមត្រូវ។",
  invalid_session: "សំណើប្រើប្រាស់សម័យមិនត្រឹមត្រូវ។",
  session_expired: "សម័យបានផុតកំណត់។",
  settle_amount_required: "ត្រូវការចំនួនសងប្រាក់។",
  invalid_settle_amount: "ចំនួនសងប្រាក់មិនត្រឹមត្រូវ។",
  settle_amount_gt_yesterday_balance: "ចំនួនសងប្រាក់ធំជាងសមតុល្យម្សិលមិញ។",
  invalid_account_status: "ស្ថានភាពគណនីមិនត្រឹមត្រូវ។",
  bet_limit_packages_required: "ត្រូវការកញ្ចប់ដែនកំណត់ភ្នាល់។",
  bet_limit_exists: "ដែនកំណត់ភ្នាល់មានរួចហើយ។",
  member_bet_limit_package_gt_one: "សមាជិកមានកញ្ចប់ដែនកំណត់ភ្នាល់លើសមួយ។",
  parent_bet_limit_not_exists: "ដែនកំណត់ភ្នាល់ឪពុក/ម្ដាយមិនមានទេ។",
  account_commission_required: "ត្រូវការកម្រៃជើងសារគណនី។",
  commission_setting_exists: "ការកំណត់កម្រៃជើងសារមានរួចហើយ។",
  parent_comm_not_exists: "ការកំណត់កម្រៃជើងសាររបស់ឪពុក/ម្ដាយមិនមាន។",
  exceeded_parent_comm: "លើសការកំណត់កម្រៃជើងសាររបស់ឪពុក/ម្ដាយ។",
  others_commission_required: "ត្រូវការកំណត់កម្រៃជើងសារផ្សេងៗ។",
  exceeded_parent_1x2: "លើសការកំណត់កម្រៃជើងសារ 1x2 របស់ឪពុក/ម្ដាយ។",
  exceeded_parent_other: "លើសការកំណត់កម្រៃជើងសារផ្សេងៗរបស់ឪពុក/ម្ដាយ។",
  hdp_commission_required: "ត្រូវការកំណត់កម្រៃជើងសារ HDP។",
  exceeded_parent_hdp_a: "លើសកម្រៃជើងសារ HPD(A) របស់ឪពុក/ម្ដាយ។",
  exceeded_parent_hdp_b: "លើសកម្រៃជើងសារ HPD(B) របស់ឪពុក/ម្ដាយ។",
  exceeded_parent_hdp_c: "លើសកម្រៃជើងសារ HPD(C) របស់ឪពុក/ម្ដាយ។",
  exceeded_parent_hdp_d: "លើសកម្រៃជើងសារ HPD(D) របស់ឪពុក/ម្ដាយ។",
  exceeded_parent_hdp_e: "លើសកម្រៃជើងសារ HPD(E) របស់ឪពុក/ម្ដាយ។",
  exceeded_parent_hdp_f: "លើសកម្រៃជើងសារ HPD(F) របស់ឪពុក/ម្ដាយ។",
  exceeded_parent_hdp_g: "លើសកម្រៃជើងសារ HPD(G) របស់ឪពុក/ម្ដាយ។",
  exceeded_parent_hdp_h: "លើសកម្រៃជើងសារ HPD(H) របស់ឪពុក/ម្ដាយ។",
  exceeded_parent_hdp_i: "លើសកម្រៃជើងសារ HPD(I) របស់ឪពុក/ម្ដាយ។",
  exceeded_parent_hdp_j: "លើសកម្រៃជើងសារ HPD(J) របស់ឪពុក/ម្ដាយ។",
  livecasino_upline_pt_required: "[Livecasino] ត្រូវការកំណត់ PT របស់អ្នកលើ។",
  livecasino_pt_setting_exists: "[Livecasino] កំណត់ PT មានរួចហើយ។",
  livecasino_parent_pt_not_exists: "[Livecasino] កំណត់ PT របស់ឪពុក/ម្ដាយមិនមាន។",
  livecasino_parent_min_not_meet: "[Livecasino] មិនដូចគ្នានឹងអប្បបរមា PT របស់ឪពុក/ម្ដាយ។",
  livecasino_exceeded_parent_pt: "[Livecasino] លើសកំណត់ PT របស់ឪពុក/ម្ដាយ។",
  livecasino_account_pt_required: "[Livecasino] ត្រូវការកំណត់ PT របស់គណនី។",
  livecasino_upline_remaining_required: "[Livecasino] ត្រូវការកំណត់ PT ខាងលើដែលនៅសល់។",
  livecasino_account_min_required: "[Livecasino] ត្រូវការកំណត់អប្បបរមា PT របស់គណនី។",
  livecasino_upline_remaining_gt_account_pt: "[Livecasino] កំណត់ PT ខាងលើដែលនៅសល់ធំជាងកំណត់ PT របស់គណនី។",
  livecasino_account_min_gt_p: "[Livecasino] កំណត់អប្បបរមា PT របស់គណនីធំជាងកំណត់ PT របស់ឪពុក/ម្ដាយ។",
  slots_upline_pt_required: "[Slots] ត្រូវការកំណត់ PT របស់អ្នកលើ។",
  slots_pt_setting_exists: "[Slots] កំណត់ PT មានរួចហើយ។",
  slots_parent_pt_not_exists: "[Slots] កំណត់ PT របស់ឪពុក/ម្ដាយមិនមាន។",
  slots_parent_min_not_meet: "[Slots] មិនត្រូវនឹងអប្បបរមា PT របស់ឪពុក/ម្ដាយ។",
  slots_exceeded_parent_pt: "[Slots] លើសកំណត់ PT របស់ឪពុក/ម្ដាយ។",
  slots_account_pt_required: "[Slots] ត្រូវការកំណត់ PT របស់គណនី។",
  slots_upline_remaining_required: "[Slots] ត្រូវការកំណត់ PT ដែលនៅសល់របស់អ្នកលើ។",
  slots_account_min_required: "[Slots] ត្រូវការកំណត់អប្បបរមា PT របស់គណនី។",
  slots_upline_remaining_gt_account_pt: "[Slots] PT ខាងលើដែលនៅសល់ធំជាង PT របស់គណនី។",
  slots_account_min_gt_pt: "[Slots] អប្បបរមា PT របស់គណនីធំជាង PT របស់ឪពុក/ម្ដាយ។",
  lotto_upline_pt_required: "[Lotto] ត្រូវការកំណត់ PT របស់អ្នកលើ។",
  lotto_pt_setting_exists: "[Lotto] កំណត់ PT មានរួចហើយ។",
  lotto_parent_pt_not_exists: "[Lotto] កំណត់ PT របស់ឪពុក/ម្ដាយមិនមាន។",
  lotto_parent_min_not_meet: "[Lotto] មិនត្រូវនឹងអប្បបរមា PT របស់ឪពុក/ម្ដាយ។",
  lotto_exceeded_parent_pt: "[Lotto] លើសកំណត់ PT របស់ឪពុក/ម្ដាយ។",
  lotto_account_pt_required: "[Lotto] ត្រូវការកំណត់ PT របស់គណនី។",
  lotto_upline_remaining_required: "[Lotto] ត្រូវការកំណត់ PT ដែលនៅសល់របស់អ្នកលើ។",
  lotto_account_min_required: "[Lotto] ត្រូវការកំណត់អប្បបរមា PT របស់គណនី។",
  lotto_upline_remaining_gt_account_pt: "[Lotto] PT ខាងលើដែលនៅសល់ធំជាង PT របស់គណនី។",
  lotto_account_min_gt_pt: "[Lotto] អប្បបរមា PT របស់គណនីធំជាង PT របស់ឪពុក/ម្ដាយ។",
  keno_upline_pt_required: "[Keno] ត្រូវការកំណត់ PT របស់អ្នកលើ។",
  keno_pt_setting_exists: "[Keno] កំណត់ PT មានរួចហើយ។",
  keno_parent_pt_not_exists: "[Keno] កំណត់ PT របស់ឪពុក/ម្ដាយមិនមាន។",
  keno_parent_min_not_meet: "[Keno] មិនត្រូវនឹងអប្បបរមា PT របស់ឪពុក/ម្ដាយ។",
  keno_exceeded_parent_pt: "[Keno] លើសកំណត់ PT របស់ឪពុក/ម្ដាយ។",
  keno_account_pt_required: "[Keno] ត្រូវការកំណត់ PT របស់គណនី។",
  keno_upline_remaining_required: "[Keno] ត្រូវការកំណត់ PT ដែលនៅសល់របស់អ្នកលើ។",
  keno_account_min_required: "[Keno] ត្រូវការកំណត់អប្បបរមា PT របស់គណនី។",
  keno_upline_remaining_gt_account_pt: "[Keno] PT ខាងលើដែលនៅសល់ធំជាង PT របស់គណនី។",
  keno_account_min_gt_pt: "[Keno] អប្បបរមា PT របស់គណនីធំជាង PT របស់ឪពុក/ម្ដាយ។",
  cockfight_upline_pt_required: "[ESports2] ត្រូវការកំណត់ PT របស់អ្នកលើ។",
  cockfight_pt_setting_exists: "[ESports2] កំណត់ PT មានរួចហើយ។",
  cockfight_parent_pt_not_exists: "[ESports2] កំណត់ PT របស់ឪពុក/ម្ដាយមិនមាន។",
  cockfight_parent_min_not_meet: "[ESports2] មិនត្រូវនឹងអប្បបរមា PT របស់ឪពុក/ម្ដាយ។",
  cockfight_exceeded_parent_pt: "[ESports2] លើសកំណត់ PT របស់ឪពុក/ម្ដាយ។",
  cockfight_account_pt_required: "[ESports2] ត្រូវការកំណត់ PT របស់គណនី។",
  cockfight_upline_remaining_required: "[ESports2] ត្រូវការកំណត់ PT ដែលនៅសល់របស់អ្នកលើ។",
  cockfight_account_min_required: "[ESports2] ត្រូវការកំណត់អប្បបរមា PT របស់គណនី។",
  cockfight_upline_remaining_gt_account_pt: "[ESports2] PT ខាងលើដែលនៅសល់ធំជាង PT របស់គណនី។",
  cockfight_account_min_gt_pt: "[ESports2] អប្បបរមា PT របស់គណនីធំជាង PT របស់ឪពុក/ម្ដាយ។",
  cockfight_exceeded_parent_commission: "[ESports2] កំណត់កម្រៃជើងសាររបស់គណនីលើស PT របស់ឪពុក/ម្ដាយ។",
  lottery_upline_pt_required: "[Lottery] ត្រូវការកំណត់ PT របស់អ្នកលើ។",
  lottery_pt_setting_exists: "[Lottery] កំណត់ PT មានរួចហើយ។",
  lottery_parent_pt_not_exists: "[Lottery] កំណត់ PT របស់ឪពុក/ម្ដាយមិនមាន។",
  lottery_parent_min_not_meet: "[Lottery] មិនត្រូវនឹងអប្បបរមា PT របស់ឪពុក/ម្ដាយ។",
  lottery_exceeded_parent_pt: "[Lottery] លើសកំណត់ PT របស់ឪពុក/ម្ដាយ។",
  lottery_account_pt_required: "[Lottery] ត្រូវការកំណត់ PT របស់គណនី។",
  lottery_upline_remaining_required: "[Lottery] ត្រូវការកំណត់ PT ដែលនៅសល់របស់អ្នកលើ។",
  lottery_account_min_required: "[Lottery] ត្រូវការកំណត់អប្បបរមា PT របស់គណនី។",
  lottery_upline_remaining_gt_account_pt: "[Lottery] PT ខាងលើដែលនៅសល់ធំជាង PT របស់គណនី។",
  lottery_account_min_gt_pt: "[Lottery] អប្បបរមា PT របស់គណនីធំជាង PT របស់ឪពុក/ម្ដាយ។",
  bet_type_required: "ត្រូវការប្រភេទភ្នាល់។",
  schedule_1_to_7_required: "ត្រូវការកាលវិភាគសងប្រាក់។",
  schedule_exists: "កាលវិភាគសងប្រាក់មិនមានទេ។",
  parent_schedule_not_exists: "កាលវិភាគសងប្រាក់របស់ឪពុក/ម្ដាយមិនមាន។",
  schedule_1_not_available: "ការសងប្រាក់នៅថ្ងៃច័ន្ទមិនអាចប្រើបានទេ។",
  schedule_2_not_available: "ការសងប្រាក់នៅថ្ងៃអង្គារមិនអាចប្រើបាន។",
  schedule_3_not_available: "ការសងប្រាក់នៅថ្ងៃពុធមិនអាចប្រើបាន។",
  schedule_4_not_available: "ការសងប្រាក់នៅថ្ងៃព្រហស្បតិ៍មិនអាចប្រើបាន។",
  schedule_5_not_available: "ការសងប្រាក់នៅថ្ងៃសុក្រ​មិនអាចប្រើបាន។",
  schedule_6_not_available: "ការសងប្រាក់នៅថ្ងៃសៅរ៍មិនអាចប្រើបាន។",
  schedule_7_not_available: "ការសងប្រាក់នៅថ្ងៃអាទិត្យមិនអាចប្រើបាន។",
  credit_limit_required: "ត្រូវការកំណត់ដែនកំណត់ឥណទាន។",
  member_credit_limit_required: "ត្រូវការកំណត់ឥណទានសមាជិក។",
  wallet_exists: "គណនីមានរួចហើយ។",
  member_credit_limit_gt_credit_limit: "ឥណទានសមាជិកធំជាងដែនកំណត់ឥណទាន។",
  parent_wallet_not_exists: "គណនីមិនមាន។",
  account_credit_limit_gt_parent: "ដែនកំណត់ឥណទានគណនីធំជាងរបស់ឪពុក/ម្ដាយ។",
  member_credit_limit_gt_parent: "ឥណទានសមាជិកធំជាងរបស់ឪពុក/ម្ដាយ។",
  exceeded_credit_limit: "លើសដែនកំណត់ឥណទាន។",
  soccer_min_bet_required: "ត្រូវការភ្នាល់អប្បបរមា។",
  soccer_max_bet_required: "ត្រូវការភ្នាល់អតិបរមា។",
  soccer_max_per_match_required: "ត្រូវការភ្នាល់អតិបរមាក្នុងមួយការប្រកួត។",
  soccer_bet_limit_exists: "ដែនកំណត់ភ្នាល់មានរួចហើយ។",
  soccer_parent_bet_limit_not_exists: "ដែនកំណត់ភ្នាល់ឪពុក/ម្ដាយមិនមាន។",
  soccer_account_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីតិចជាងរបស់ឪពុក/ម្ដាយ។",
  soccer_account_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីធំជាងរបស់ឪពុក/ម្ដាយ។",
  soccer_account_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយការប្រកួតធំជាងរបស់ឪពុក/ម្ដាយ។",
  basketball_min_bet_required: "ត្រូវការភ្នាល់អប្បបរមា។",
  basketball_max_bet_required: "ត្រូវការភ្នាល់អតិបរមា។",
  basketball_max_per_match_required: "ត្រូវការភ្នាល់អតិបរមាក្នុងមួយការប្រកួត។",
  basketball_bet_limit_exists: "ដែនកំណត់ភ្នាល់មានរួចហើយ។",
  basketball_parent_bet_limit_not_exists: "ដែនកំណត់ភ្នាល់ឪពុក/ម្ដាយមិនមាន។",
  basketball_account_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីតិចជាងរបស់ឪពុក/ម្ដាយ។",
  basketball_account_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីធំជាងរបស់ឪពុក/ម្ដាយ។",
  basketball_account_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយការប្រកួតធំជាងរបស់ឪពុក/ម្ដាយ។",
  tennis_min_bet_required: "ត្រូវការភ្នាល់អប្បបរមា។",
  tennis_max_bet_required: "ត្រូវការភ្នាល់អតិបរមា។",
  tennis_max_per_match_required: "ត្រូវការភ្នាល់អតិបរមាក្នុងមួយការប្រកួត។",
  tennis_bet_limit_exists: "ដែនកំណត់ភ្នាល់មានរួចហើយ។",
  tennis_parent_bet_limit_not_exists: "ដែនកំណត់ភ្នាល់ឪពុក/ម្ដាយមិនមាន។",
  tennis_account_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីតិចជាងរបស់ឪពុក/ម្ដាយ។",
  tennis_account_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីធំជាងរបស់ឪពុក/ម្ដាយ។",
  tennis_account_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយការប្រកួតធំជាងរបស់ឪពុក/ម្ដាយ។",
  baseball_min_bet_required: "ត្រូវការភ្នាល់អប្បបរមា។",
  baseball_max_bet_required: "ត្រូវការភ្នាល់អតិបរមា។",
  baseball_max_per_match_required: "ត្រូវការភ្នាល់អតិបរមាក្នុងមួយការប្រកួត។",
  baseball_bet_limit_exists: "ដែនកំណត់ភ្នាល់មានរួចហើយ។",
  baseball_parent_bet_limit_not_exists: "ដែនកំណត់ភ្នាល់ឪពុក/ម្ដាយមិនមាន។",
  baseball_account_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីតិចជាងរបស់ឪពុក/ម្ដាយ។",
  baseball_account_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីធំជាងរបស់ឪពុក/ម្ដាយ។",
  baseball_account_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយការប្រកួតធំជាងរបស់ឪពុក/ម្ដាយ។",
  parlay_min_bet_required: "ត្រូវការភ្នាល់អប្បបរមា។",
  parlay_max_bet_required: "ត្រូវការភ្នាល់អតិបរមា។",
  parlay_max_per_match_required: "ត្រូវការភ្នាល់អតិបរមាក្នុងមួយការប្រកួត។",
  parlay_bet_limit_exists: "ដែនកំណត់ភ្នាល់មានរួចហើយ។",
  parlay_parent_bet_limit_not_exists: "ដែនកំណត់ភ្នាល់ឪពុក/ម្ដាយមិនមាន។",
  parlay_account_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីតិចជាងរបស់ឪពុក/ម្ដាយ។",
  parlay_account_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីធំជាងរបស់ឪពុក/ម្ដាយ។",
  parlay_account_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយការប្រកួតធំជាងរបស់ឪពុក/ម្ដាយ។",
  esports_min_bet_required: "ត្រូវការភ្នាល់អប្បបរមា។",
  esports_max_bet_required: "ត្រូវការភ្នាល់អតិបរមា។",
  esports_max_per_match_required: "ត្រូវការភ្នាល់អតិបរមាក្នុងមួយការប្រកួត។",
  esports_bet_limit_exists: "ដែនកំណត់ភ្នាល់មានរួចហើយ។",
  esports_parent_bet_limit_not_exists: "ដែនកំណត់ភ្នាល់ឪពុក/ម្ដាយមិនមាន។",
  esports_account_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីតិចជាងរបស់ឪពុក/ម្ដាយ។",
  esports_account_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីធំជាងរបស់ឪពុក/ម្ដាយ។",
  esports_account_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយការប្រកួតធំជាងរបស់ឪពុក/ម្ដាយ។",
  others_min_bet_required: "ត្រូវការភ្នាល់អប្បបរមា។",
  others_max_bet_required: "ត្រូវការភ្នាល់អតិបរមា។",
  others_max_per_match_required: "ត្រូវការភ្នាល់អតិបរមាក្នុងមួយការប្រកួត។",
  others_bet_limit_exists: "ដែនកំណត់ភ្នាល់មានរួចហើយ។",
  others_parent_bet_limit_not_exists: "ដែនកំណត់ភ្នាល់ឪពុក/ម្ដាយមិនមាន។",
  others_account_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីតិចជាងរបស់ឪពុក/ម្ដាយ។",
  others_account_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីធំជាងរបស់ឪពុក/ម្ដាយ។",
  others_account_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយការប្រកួតធំជាងរបស់ឪពុក/ម្ដាយ។",
  used_credit_gt_credit_limit: "ការប្រើប្រាស់ឥណទានលើសពីដែនកំណត់។",
  bet_limit_setting_not_exists: "ការកំណត់ដែនភ្នាល់មិនមាន។",
  parent_bet_limit_setting_not_exists: "ការកំណត់ដែនភ្នាល់របស់ឪពុក/ម្ដាយមិនមាន។",
  package_not_exists_in_parent: "ការកំណត់កញ្ចប់ដែនភ្នាល់របស់ឪពុក/ម្ដាយមិនមាន។",
  soccer_bet_limit_setting_not_exists: "ការកំណត់ដែនភ្នាល់បាល់ទាត់មិនមាន។",
  soccer_update_interval_violated: "បានលើសចន្លោះពេលបច្ចុប្បន្នភាព។",
  basketball_bet_limit_setting_not_exists: "ការកំណត់ដែនភ្នាល់បាស្កែតបាល់មិនមាន។",
  basketball_update_interval_violated: "បានលើសចន្លោះពេលបច្ចុប្បន្នភាព។",
  tennis_bet_limit_setting_not_exists: "ការកំណត់ដែនភ្នាល់ទឺនីសមិនមាន។",
  tennis_update_interval_violated: "បានលើសចន្លោះពេលបច្ចុប្បន្នភាព។",
  baseball_bet_limit_setting_not_exists: "ការកំណត់ដែនភ្នាល់បេសបាល់មិនមាន។",
  baseball_update_interval_violated: "បានលើសចន្លោះពេលបច្ចុប្បន្នភាព។",
  parlay_bet_limit_setting_not_exists: "ការកំណត់ដែនភ្នាល់ប៉ាឡេលមិនមាន។",
  parlay_update_interval_violated: "បានលើសចន្លោះពេលបច្ចុប្បន្នភាព។",
  esports_bet_limit_setting_not_exists: "ការកំណត់ដែនភ្នាល់ Esports មិនមាន។",
  esports_update_interval_violated: "បានលើសចន្លោះពេលបច្ចុប្បន្នភាព។",
  others_bet_limit_setting_not_exists: "ការកំណត់ដែនភ្នាល់ផ្សេងទៀតមិនមាន។",
  others_update_interval_violated: "បានលើសចន្លោះពេលបច្ចុប្បន្នភាព។",
  soccer_parent_bet_limit_setting_not_exists: "ការកំណត់ដែនភ្នាល់ឪពុក/ម្ដាយបាល់ទាត់មិនមាន។",
  soccer_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីបាល់ទាត់តិចជាងឪពុក/ម្ដាយ។",
  soccer_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីបាល់ទាត់ធំជាងឪពុក/ម្ដាយ។",
  soccer_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយការប្រកួតបាល់ទាត់ធំជាងឪពុក/ម្ដាយ។",
  basketball_parent_bet_limit_setting_not_exists: "ការកំណត់ដែនភ្នាល់ឪពុក/ម្ដាយបាស្កែតបាល់មិនមាន។",
  basketball_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីបាស្កែតបាល់តិចជាងឪពុក/ម្ដាយ។",
  basketball_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីបាស្កែតបាល់ធំជាងឪពុក/ម្ដាយ។",
  basketball_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយការប្រកួតបាស្កែតបាល់ធំជាងឪពុក/ម្ដាយ។",
  tennis_parent_bet_limit_setting_not_exists: "ការកំណត់ដែនភ្នាល់ឪពុក/ម្ដាយទឺនីសមិនមាន។",
  tennis_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីទឺនីសតិចជាងឪពុក/ម្ដាយ។",
  tennis_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីទឺនីសធំជាងឪពុក/ម្ដាយ។",
  tennis_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយការប្រកួតទឺនីសធំជាងឪពុក/ម្ដាយ។",
  baseball_parent_bet_limit_setting_not_exists: "ការកំណត់ដែនភ្នាល់ឪពុក/ម្ដាយបេសបាល់មិនមាន។",
  baseball_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីបេសបាល់តិចជាងឪពុក/ម្ដាយ។",
  baseball_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីបេសបាល់ធំជាងឪពុក/ម្ដាយ។",
  baseball_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយការប្រកួតបេសបាល់ធំជាងឪពុក/ម្ដាយ។",
  parlay_parent_bet_limit_setting_not_exists: "ការកំណត់ដែនភ្នាល់ឪពុក/ម្ដាយប៉ាឡេលមិនមាន។",
  parlay_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីប៉ាឡេលតិចជាងឪពុក/ម្ដាយ។",
  parlay_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីប៉ាឡេលធំជាងឪពុក/ម្ដាយ។",
  parlay_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយការប្រកួតប៉ាឡេលធំជាងឪពុក/ម្ដាយ។",
  esports_parent_bet_limit_setting_not_exists: "ការកំណត់ដែនភ្នាល់ឪពុក/ម្ដាយ Esports មិនមាន។",
  esports_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនី Esports តិចជាងឪពុក/ម្ដាយ។",
  esports_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនី Esports ធំជាងឪពុក/ម្ដាយ។",
  esports_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយការប្រកួត Esports ធំជាងឪពុក/ម្ដាយ។",
  others_parent_bet_limit_setting_not_exists: "ការកំណត់ដែនភ្នាល់ឪពុក/ម្ដាយ Esports មិនមាន។",
  others_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនី Esports តិចជាងឪពុក/ម្ដាយ។",
  others_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនី Esports ធំជាងឪពុក/ម្ដាយ។",
  others_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយការប្រកួត Esports ធំជាងឪពុក/ម្ដាយ។",
  update_interval_violated: "បានលើសចន្លោះពេលបច្ចុប្បន្នភាព។",
  exceeded_parent_others: "លើសការកំណត់កម្មសិទ្ធិផ្សេងទៀតរបស់ឪពុក/ម្ដាយ។",
  exceeded_parent_hdp: "លើសការកំណត់ដែន HDP របស់ឪពុក/ម្ដាយ។",
  no_information_available: "គ្មានព័ត៌មានអាចប្រើបានទេ។",
  request_processing: "កំពុងដំណើរការសំណើ...",
  new_login_id_format_error: "អាចប្រើតែលេខនិងអក្សរតូច a ដល់ z ប៉ុណ្ណោះ។",
  account_id_format_error: "អាចប្រើតែលេខនិងអក្សរតូច a ដល់ z ប៉ុណ្ណោះ។",
  inactive_account: "គណនីត្រូវបានបិទ/ផ្អាក។ សូមទាក់ទងអ្នកប្រតិបត្តិការ។",

  sportsbook_account_pt_gt_92: "PT របស់ Super Senior មិនអាចលើស 92% បានទេ។",
  pending_result: "កំពុងរងចាំលទ្ធផល",
  insufficient_balance: "ប្រាក់មិនគ្រប់គ្រាន់",
  ok: "ជោគជ័យ",
  settlement_warning: "ការព្រមាន៖ ប្រសិនបើបានផ្ទេរប្រាក់ចេញទាំងស្រុង សមាជិកខាងក្រោមអាចមានឥណទានភ្នាល់អវិជ្ជមាន ហើយអាចបាត់បង់ច្រើនជាងឥណទានដែលបានផ្តល់។",
  jackpot_alert: "សម្រាប់ការបង់ប្រាក់ជ័យលាភី jackpot មួយណាដែលលើស MYR 100,000 (THB 1,000,000) WBET នឹងទទួលខុសត្រូវលើចំនួនទាំងមូល។",
  accumulate_alert: "ដែនកំណត់ឈ្នះនឹងកំណត់ឡើងវិញនៅពេលការបង់ប្រាក់ត្រូវបានដោះសោ។",
  filter_yesterday_balance: "បង្ហាញសមតុល្យម្សិលមិញដែលមិនស្មើនឹង 0",

  soccer_hdp_account_pt_lt_downline: "[បាល់ទាត់] PT គណនី HDP តិចជាងខាងក្រោម",
  soccer_1x2_account_pt_lt_downline: "[បាល់ទាត់] PT គណនី 1X2 តិចជាងខាងក្រោម",
  soccer_others_account_pt_lt_downline: "[បាល់ទាត់] PT គណនីផ្សេងៗតិចជាងខាងក្រោម",
  soccer_hdp_exceeded_parent_pt: "[បាល់ទាត់] លើសការកំណត់ PT HDP របស់ឪពុក/ម្ដាយ។",
  soccer_1x2_exceeded_parent_pt: "[បាល់ទាត់] លើសការកំណត់ PT 1X2 របស់ឪពុក/ម្ដាយ។",
  soccer_others_exceeded_parent_pt: "[បាល់ទាត់] លើសការកំណត់ PT ផ្សេងៗរបស់ឪពុក/ម្ដាយ។",
  parlay_account_pt_lt_downline: "[Parlay] PT គណនីតិចជាងខាងក្រោម",
  account_pt_lt_downline: "PT គណនីតិចជាងខាងក្រោម",
  player_alert_tooltips: "(ចំណាំ៖ បង្ហាញតែសមាជិកដែលមានឥណទានតិចជាងភ្នាល់អប្បបរមា)",

  relogin_seconds: "សូមចូលប្រើឡើងវិញបន្ទាប់ពី {timer} វិនាទី",
  relogin_hours: "សូមចូលប្រើឡើងវិញបន្ទាប់ពី {timer} ម៉ោង",
  relogin_tooltips: "ប្រសិនបើអ្នកត្រូវការជំនួយក្នុងការដោះសោគណនី សូមទាក់ទងសេវាអតិថិជន។",
  last_modified_slot: "ពេលវេលាដែលអ្នកបានកែចុងក្រោយគឺ {oldTime}។ សូមព្យាយាមម្តងទៀតនៅ {newTime}។",

  account_min_gt_pt: "ការកំណត់ PT អប្បបរមារបស់គណនីធំជាង PT របស់ឪពុក/ម្ដាយ។",
  account_min_required: "ត្រូវការកំណត់ PT អប្បបរមារបស់គណនី។",
  account_pt_required: "ត្រូវការកំណត់ PT របស់គណនី។",
  agent_id_required: "ត្រូវការលេខសម្គាល់ភ្នាក់ងារ។",
  amount_required: "ត្រូវការចំនួនទឹកប្រាក់។",
  at_least_one_schedule_required: "ត្រូវការកំណត់ពេលវេលាអតិបបរមាមួយយ៉ាងតិច។",
  authority_option_required: "ត្រូវការកំណត់ជម្រើសសិទ្ធិ។",

  baseball_min_bet_gt_max_bet: "ភ្នាល់អប្បបរមា Baseball ធំជាងអតិបរមា។",
  baseball_max_bet_gt_max_per_match: "ភ្នាល់អតិបរមា Baseball ធំជាងអតិបរមាក្នុងមួយការប្រកួត។",
  basketball_max_bet_gt_max_per_match: "ភ្នាល់អតិបរមា Basketball ធំជាងអតិបរមាក្នុងមួយការប្រកួត។",
  basketball_min_bet_gt_max_bet: "ភ្នាល់អប្បបរមា Basketball ធំជាងអតិបរមា។",
  brand_name_required: "ត្រូវការឈ្មោះម៉ាក",
  client_ip_required: "ត្រូវការ IP អតិថិជន",

  cockfight_bet_limit_exists: "[ESports2] ដែនកំណត់ភ្នាល់មានរួចហើយ។",
  cockfight_bet_limit_packages_required: "[ESports2] ត្រូវការកញ្ចប់ដែនកំណត់ភ្នាល់។",
  cockfight_commission_required: "[ESports2] ត្រូវការការកំណត់កម្រៃជើងសារ។",
  cockfight_commission_setting_exists: "[ESports2] ការកំណត់កម្រៃជើងសារមានរួចហើយ។",
  cockfight_invalid_bet_limit_package: "[ESports2] កញ្ចប់ដែនកំណត់ភ្នាល់មិនត្រឹមត្រូវ។",
  cockfight_member_bet_limit_package_gt_one: "[ESports2] សមាជិកមានកញ្ចប់ដែនកំណត់ភ្នាល់ច្រើនជាងមួយ។",
  cockfight_parent_bet_limit_not_exists: "[ESports2] ដែនកំណត់ភ្នាល់ឪពុក/ម្ដាយមិនមាន។",
  cockfight_parent_commission_not_exists: "[ESports2] កម្រៃជើងសារការបស់ឪពុក/ម្ដាយមិនមាន។",

  credit_limit_gt_parent_member_credit_limit: "ដែនកំណត់ឥណទានធំជាងដែនកំណត់សមាជិករបស់ឪពុក/ម្ដាយ។",
  downline_limit_exceeded: "លើសដែនកំណត់ខាងក្រោម។",

  esports_max_bet_gt_max_per_match: "[ESports] ភ្នាល់អតិបរមា ធំជាងអតិបរមាក្នុងមួយការប្រកួត។",
  esports_min_bet_gt_max_bet: "[ESports] ភ្នាល់អប្បបរមា ធំជាងអតិបរមា។",

  exceeded_parent_parlay_a: "លើសការកំណត់ PT parlay A របស់ឪពុក/ម្ដាយ។",
  exceeded_parent_parlay_b: "លើសការកំណត់ PT parlay B របស់ឪពុក/ម្ដាយ។",
  exceeded_parent_pt: "លើសការកំណត់ PT parlay របស់ឪពុក/ម្ដាយ។",

  hdp_account_min_gt_pt: "អប្បបរមាគណនី HDP ធំជាង PT របស់ឪពុក/ម្ដាយ។",
  hdp_account_min_required: "ត្រូវការកំណត់អប្បបរមារបស់គណនី HDP។",
  hdp_account_pt_required: "ត្រូវការកំណត់ PT របស់គណនី HDP។",
  hdp_exceeded_parent_commission: "HDP លើសកម្រៃជើងសាររបស់ឪពុក/ម្ដាយ។",
  hdp_exceeded_parent_pt: "HDP លើស PT របស់ឪពុក/ម្ដាយ។",
  hdp_mmo_account_min_gt_pt: "អប្បបរមាគណនី HDP MMO ធំជាង PT របស់ឪពុក/ម្ដាយ។",
  hdp_mmo_account_min_required: "ត្រូវការកំណត់អប្បបរមារបស់គណនី HDP MMO។",
  hdp_mmo_account_pt_required: "ត្រូវការកំណត់ PT របស់គណនី HDP MMO។",
  hdp_mmo_commission_required: "ត្រូវការកម្រៃជើងសាររបស់ HDP MMO។",
  hdp_mmo_exceeded_parent_commission: "HDP MMO លើសកម្រៃជើងសាររបស់ឪពុក/ម្ដាយ។",
  hdp_mmo_exceeded_parent_pt: "HDP MMO លើស PT របស់ឪពុក/ម្ដាយ។",
  hdp_mmo_parent_min_not_meet: "HDP MMO មិនស្មើនឹងអប្បបរមារបស់ឪពុក/ម្ដាយ។",
  hdp_mmo_parent_pt_not_exists: "PT របស់ឪពុក/ម្ដាយ HDP MMO មិនមាន។",
  hdp_mmo_pt_setting_exists: "ការកំណត់ PT របស់ HDP MMO មានរួចហើយ។",
  hdp_mmo_upline_pt_required: "ត្រូវការកំណត់ PT របស់ Upline HDP MMO។",
  hdp_mmo_upline_remaining_gt_account_pt: "PT នៅសល់របស់ Upline HDP MMO ធំជាង PT របស់គណនី។",
  hdp_mmo_upline_remaining_required: "ត្រូវការកំណត់ PT នៅសល់របស់ Upline HDP MMO។",
  hdp_package_required: "ត្រូវការកញ្ចប់ HDP។",
  hdp_packages_not_exists: "កញ្ចប់ HDP មិនមាន។",
  hdp_packages_required: "ត្រូវការកញ្ចប់ HDP។",
  hdp_parent_min_not_meet: "HDP មិនស្មើនឹងអប្បបរមារបស់ឪពុក/ម្ដាយ។",
  hdp_parent_pt_not_exists: "PT របស់ឪពុក/ម្ដាយ HDP មិនមាន។",
  hdp_pt_setting_exists: "ការកំណត់ PT របស់ HDP មានរួចហើយ។",
  hdp_required: "ត្រូវការ HDP។",
  hdp_upline_pt_required: "ត្រូវការកំណត់ PT របស់ Upline HDP។",
  hdp_upline_remaining_gt_account_pt: "PT នៅសល់របស់ Upline HDP ធំជាង PT របស់គណនី។",
  hdp_upline_remaining_required: "ត្រូវការកំណត់ PT នៅសល់របស់ Upline HDP។",

  inactive_profile: "ប្រវត្តិរូបមិនសកម្ម។",
  incorrect_format: "ទ្រង់ទ្រាយមិនត្រឹមត្រូវ។",
  invalid_amount: "ចំនួនមិនត្រឹមត្រូវ។",
  invalid_baseball_max_bet: "ភ្នាល់អតិបរមា Baseball មិនត្រឹមត្រូវ។",
  invalid_baseball_max_per_match: "ភ្នាល់អតិបរមា Baseball ក្នុងមួយការប្រកួតមិនត្រឹមត្រូវ។",
  invalid_baseball_min_bet: "ភ្នាល់អប្បបរមា Baseball មិនត្រឹមត្រូវ។",
  invalid_basketball_max_bet: "ភ្នាល់អតិបរមា Basketball មិនត្រឹមត្រូវ។",
  invalid_basketball_max_per_match: "ភ្នាល់អតិបរមា Basketball ក្នុងមួយការប្រកួតមិនត្រឹមត្រូវ។",
  invalid_basketball_min_bet: "ភ្នាល់អប្បបរមា Basketball មិនត្រឹមត្រូវ។",
  invalid_esports_max_bet: "ភ្នាល់អតិបរមា Esports មិនត្រឹមត្រូវ។",
  invalid_esports_max_per_match: "ភ្នាល់អតិបរមា Esports ក្នុងមួយការប្រកួតមិនត្រឹមត្រូវ។",
  invalid_esports_min_bet: "ភ្នាល់អប្បបរមា Esports មិនត្រឹមត្រូវ។",
  invalid_method: "វិធីសាស្រ្តមិនត្រឹមត្រូវ។",
  invalid_others_max_bet: "ភ្នាល់អតិបរមាផ្សេងៗមិនត្រឹមត្រូវ។",
  invalid_others_max_per_match: "ភ្នាល់អតិបរមា ក្នុងមួយការប្រកួត ផ្សេងៗមិនត្រឹមត្រូវ។",
  invalid_others_min_bet: "ភ្នាល់អប្បបរមាផ្សេងៗមិនត្រឹមត្រូវ។",
  invalid_parlay_max_bet: "ភ្នាល់អតិបរមា Parlay មិនត្រឹមត្រូវ។",
  invalid_parlay_max_per_match: "ភ្នាល់អតិបរមា Parlay ក្នុងមួយការប្រកួតមិនត្រឹមត្រូវ។",
  invalid_parlay_min_bet: "ភ្នាល់អប្បបរមា Parlay មិនត្រឹមត្រូវ។",
  invalid_soccer_max_bet: "ភ្នាល់អតិបរមា បាល់ទាត់ មិនត្រឹមត្រូវ។",
  invalid_soccer_max_per_match: "ភ្នាល់អតិបរមា បាល់ទាត់ ក្នុងមួយការប្រកួត មិនត្រឹមត្រូវ។",
  invalid_soccer_min_bet: "ភ្នាល់អប្បបរមា បាល់ទាត់ មិនត្រឹមត្រូវ។",
  invalid_tennis_max_bet: "ភ្នាល់អតិបរមា Tennis មិនត្រឹមត្រូវ។",
  invalid_tennis_max_per_match: "ភ្នាល់អតិបរមា Tennis ក្នុងមួយការប្រកួត មិនត្រឹមត្រូវ។",
  invalid_tennis_min_bet: "ភ្នាល់អប្បបរមា Tennis មិនត្រឹមត្រូវ។",

  keno_bet_limit_exists: "[Keno] ដែនកំណត់ភ្នាល់មានរួចហើយ។",
  keno_bet_limit_packages_required: "[Keno] ត្រូវការកញ្ចប់ដែនកំណត់ភ្នាល់។",
  keno_commission_required: "[Keno] ត្រូវការការកំណត់កម្រៃជើងសារ។",
  keno_commission_setting_exists: "[Keno] ការកំណត់កម្រៃជើងសារ មានរួចហើយ។",
  keno_exceeded_parent_commission: "[Keno] ការកំណត់កម្រៃជើងសាររបស់គណនី ធំជាងរបស់ឪពុក/ម្ដាយ។",
  keno_invalid_bet_limit_package: "[Keno] កញ្ចប់ដែនកំណត់ភ្នាល់មិនត្រឹមត្រូវ។",
  keno_member_bet_limit_package_gt_one: "[Keno] សមាជិកមានកញ្ចប់ដែនកំណត់ភ្នាល់ច្រើនជាងមួយ។",
  keno_parent_bet_limit_not_exists: "[Keno] ដែនកំណត់ភ្នាល់របស់ឪពុក/ម្ដាយមិនមាន។",
  keno_parent_commission_not_exists: "[Keno] កម្រៃជើងសាររបស់ឪពុក/ម្ដាយមិនមាន។",

  livecasino_account_min_gt_pt: "[Livecasino] ការកំណត់ PT អប្បបរមារបស់គណនី ធំជាង PT របស់ឪពុក/ម្ដាយ។",
  livecasino_bet_limit_exists: "[Livecasino] ដែនកំណត់ភ្នាល់មានរួចហើយ។",
  livecasino_bet_limit_packages_required: "[Livecasino] ត្រូវការកញ្ចប់ដែនកំណត់ភ្នាល់។",
  livecasino_commission_required: "[Livecasino] ត្រូវការការកំណត់កម្រៃជើងសារ។",
  livecasino_commission_setting_exists: "[Livecasino] ការកំណត់កម្រៃជើងសារមានរួចហើយ។",
  livecasino_exceeded_parent_commission: "[Livecasino] ការកំណត់កម្រៃជើងសាររបស់គណនី ធំជាងរបស់ឪពុក/ម្ដាយ។",
  livecasino_invalid_bet_limit_package: "[Livecasino] កញ្ចប់ដែនកំណត់ភ្នាល់មិនត្រឹមត្រូវ។",
  livecasino_member_bet_limit_package_gt_one: "[Livecasino] សមាជិកមានកញ្ចប់ដែនកំណត់ភ្នាល់ច្រើនជាងមួយ។",
  livecasino_parent_bet_limit_not_exists: "[Livecasino] ដែនកំណត់ភ្នាល់របស់ឪពុក/ម្ដាយមិនមាន។",
  livecasino_parent_commission_not_exists: "[Livecasino] កម្រៃជើងសាររបស់ឪពុក/ម្ដាយមិនមាន។",

  login_ip_required: "ត្រូវការលេខ IP ចូលប្រើ។",
  lottery_1d_parent_min_not_meet: "[Lottery 1D] មិនស្មើនឹងអប្បបរមារបស់ឪពុក/ម្ដាយ។",
  lottery_1d_account_min_gt_pt: "[Lottery 1D] ការកំណត់ PT អប្បបរមារបស់គណនី ធំជាង PT របស់ឪពុក/ម្ដាយ។",
  lottery_1d_account_min_required: "[Lottery 1D] ត្រូវការកំណត់ PT អប្បបរមារបស់គណនី។",
  lottery_1d_account_pt_lt_downline: "[Lottery 1D] PT របស់គណនី តិចជាងរបស់បន្ទាត់ក្រោម។",
  lottery_1d_account_pt_required: "[Lottery 1D] ត្រូវការកំណត់ PT របស់គណនី។",
  lottery_1d_commission_required: "[Lottery 1D] ត្រូវការកំណត់កម្រៃជើងសារ។",
  lottery_1d_exceeded_parent_comm: "[Lottery 1D] ការកំណត់កម្រៃជើងសាររបស់គណនី ធំជាងរបស់ឪពុក/ម្ដាយ។",
  lottery_1d_exceeded_parent_commission: "[Lottery 1D] ការកំណត់កម្រៃជើងសាររបស់គណនី ធំជាងរបស់ឪពុក/ម្ដាយ។",
  lottery_1d_exceeded_parent_pt: "[Lottery 1D] លើស PT របស់ឪពុក/ម្ដាយ។",
  lottery_1d_pt_setting_exists: "[Lottery 1D] ការកំណត់ PT របស់ឪពុក/ម្ដាយ មានរួចហើយ។",
  lottery_1d_parent_pt_not_exists: "[Lottery 1D] ការកំណត់ PT របស់ឪពុក/ម្ដាយ មិនមាន។",
  lottery_1d_pt_setting_not_exists: "[Lottery 1D] ការកំណត់ PT មិនមាន។",
  lottery_1d_upline_pt_required: "[Lottery 1D] ត្រូវការកំណត់ PT របស់ Upline។",
  lottery_1d_upline_remaining_gt_account_pt: "[Lottery 1D] PT នៅសល់របស់ Upline ធំជាង PT របស់គណនី។",
  lottery_1d_upline_remaining_required: "[Lottery 1D] ត្រូវការកំណត់ PT នៅសល់របស់ Upline។",

  lottery_2d_account_min_gt_pt: "[Lottery 2D] ការកំណត់ PT អប្បបរមារបស់គណនី ធំជាង PT របស់ឪពុក/ម្ដាយ។",
  lottery_2d_account_min_required: "[Lottery 2D] ត្រូវការកំណត់ PT អប្បបរមារបស់គណនី។",
  lottery_2d_account_pt_lt_downline: "[Lottery 2D] PT របស់គណនី តិចជាងរបស់បន្ទាត់ក្រោម។",
  lottery_2d_account_pt_required: "[Lottery 2D] ត្រូវការកំណត់ PT របស់គណនី។",
  lottery_2d_commission_required: "[Lottery 2D] ត្រូវការកំណត់កម្រៃជើងសារ។",
  lottery_2d_exceeded_parent_comm: "[Lottery 2D] ការកំណត់កម្រៃជើងសាររបស់គណនី ធំជាងរបស់ឪពុក/ម្ដាយ។",
  lottery_2d_exceeded_parent_commission: "[Lottery 2D] ការកំណត់កម្រៃជើងសាររបស់គណនី ធំជាងរបស់ឪពុក/ម្ដាយ។",
  lottery_2d_exceeded_parent_pt: "[Lottery 2D] លើស PT របស់ឪពុក/ម្ដាយ។",
  lottery_2d_parent_min_not_meet: "[Lottery 2D] មិនស្មើនឹងអប្បបរមារបស់ឪពុក/ម្ដាយ។",
  lottery_2d_parent_pt_not_exists: "[Lottery 2D] ការកំណត់ PT របស់ឪពុក/ម្ដាយ មិនមាន។",
  lottery_2d_pt_setting_exists: "[Lottery 2D] ការកំណត់ PT របស់ឪពុក/ម្ដាយ មានរួចហើយ។",
  lottery_2d_pt_setting_not_exists: "[Lottery 1D] ការកំណត់ PT មិនមាន។",
  lottery_2d_upline_pt_required: "[Lottery 2D] ត្រូវការកំណត់ PT របស់ Upline។",
  lottery_2d_upline_remaining_gt_account_pt: "[Lottery 2D] PT នៅសល់របស់ Upline ធំជាង PT របស់គណនី។",
  lottery_2d_upline_remaining_required: "[Lottery 2D] ត្រូវការកំណត់ PT នៅសល់របស់ Upline។",

  lottery_3d_commission_required: "[Lottery 3D] ត្រូវការកំណត់កម្រៃជើងសារ។",
  lottery_3d_exceeded_parent_comm: "[Lottery 3D] ការកំណត់កម្រៃជើងសាររបស់គណនី ធំជាងរបស់ឪពុក/ម្ដាយ។",
  lottery_3d_exceeded_parent_commission: "[Lottery 3D] ការកំណត់កម្រៃជើងសាររបស់គណនី ធំជាងរបស់ឪពុក/ម្ដាយ។",
  lottery_4d_commission_required: "[Lottery 4D] ត្រូវការកំណត់កម្រៃជើងសារ។",
  lottery_4d_exceeded_parent_comm: "[Lottery 4D] ការកំណត់កម្រៃជើងសាររបស់គណនី ធំជាងរបស់ឪពុក/ម្ដាយ។",
  lottery_4d_exceeded_parent_commission: "[Lottery 4D] ការកំណត់កម្រៃជើងសាររបស់គណនី ធំជាងរបស់ឪពុក/ម្ដាយ។",
  lottery_bet_limit_exists: "[Lottery] ដែនកំណត់ភ្នាល់មានរួចហើយ។",
  lottery_bet_limit_packages_required: "[Lottery] ត្រូវការកញ្ចប់ដែនកំណត់ភ្នាល់។",
  lottery_commission_setting_exists: "[Lottery] ការកំណត់កម្រៃជើងសារមានរួចហើយ។",
  lottery_invalid_bet_limit_package: "[Lottery] កញ្ចប់ដែនកំណត់ភ្នាល់មិនត្រឹមត្រូវ។",
  lottery_member_bet_limit_package_gt_one: "[Lottery] សមាជិកមានកញ្ចប់ដែនកំណត់ភ្នាល់ច្រើនជាងមួយ។",
  lottery_parent_bet_limit_not_exists: "[Lottery] ដែនកំណត់ភ្នាល់របស់ឪពុក/ម្ដាយមិនមាន។",
  lottery_parent_commission_not_exists: "[Lottery] កម្រៃជើងសាររបស់ឪពុក/ម្ដាយមិនមាន។",

  lotto_bet_limit_exists: "[Lotto] ដែនកំណត់ភ្នាល់មានរួចហើយ។",
  lotto_bet_limit_packages_required: "[Lotto] ត្រូវការកញ្ចប់ដែនកំណត់ភ្នាល់។",
  lotto_commission_required: "[Lotto] ត្រូវការកំណត់កម្រៃជើងសារ។",
  lotto_commission_setting_exists: "[Lotto] ការកំណត់កម្រៃជើងសារមានរួចហើយ។",
  lotto_exceeded_parent_commission: "[Lotto] ការកំណត់កម្រៃជើងសាររបស់គណនី ធំជាងរបស់ឪពុក/ម្ដាយ។",
  lotto_invalid_bet_limit_package: "[Lotto] កញ្ចប់ដែនកំណត់ភ្នាល់មិនត្រឹមត្រូវ។",
  lotto_member_bet_limit_package_gt_one: "[Lotto] សមាជិកមានកញ្ចប់ដែនកំណត់ភ្នាល់ច្រើនជាងមួយ។",
  lotto_parent_bet_limit_not_exists: "[Lotto] ដែនកំណត់ភ្នាល់របស់ឪពុក/ម្ដាយមិនមាន។",
  lotto_parent_commission_not_exists: "[Lotto] កម្រៃជើងសាររបស់ឪពុក/ម្ដាយមិនមាន។",

  method_required: "ត្រូវការវិធីសាស្ត្រ។",
  no_accumulate_win: "គ្មានការឈ្នះដែលបានបង្រួម។",

  one_x_two_account_min_gt_pt: "[1X2] ការកំណត់ PT អប្បបរមារបស់គណនី ធំជាង PT របស់ឪពុក/ម្ដាយ។",
  one_x_two_account_min_required: "[1X2] ត្រូវការកំណត់ PT អប្បបរមារបស់គណនី។",
  one_x_two_account_pt_required: "[1X2] ត្រូវការកំណត់ PT របស់គណនី។",
  one_x_two_commission_required: "[1X2] ត្រូវការកំណត់កម្រៃជើងសារ។",
  one_x_two_exceeded_parent_commission: "[1X2] ការកំណត់កម្រៃជើងសាររបស់គណនី ធំជាងរបស់ឪពុក/ម្ដាយ។",
  one_x_two_exceeded_parent_pt: "[1X2] លើស PT របស់ឪពុក/ម្ដាយ។",
  one_x_two_parent_min_not_meet: "[1X2] មិនស្មើនឹងអប្បបរមារបស់ឪពុក/ម្ដាយ។",
  one_x_two_parent_pt_not_exists: "[1X2] ការកំណត់ PT របស់ឪពុក/ម្ដាយមិនមាន។",
  one_x_two_pt_setting_exists: "[1X2] ការកំណត់ PT មានរួចហើយ។",
  one_x_two_upline_pt_required: "[1X2] ត្រូវការកំណត់ PT របស់ Upline។",
  one_x_two_upline_remaining_gt_account_pt: "[1X2] PT នៅសល់របស់ Upline ធំជាង PT របស់គណនី។",
  one_x_two_upline_remaining_required: "[1X2] ត្រូវការកំណត់ PT នៅសល់របស់ Upline។",

  others_account_min_gt_pt: "[Others] ការកំណត់ PT អប្បបរមារបស់គណនី ធំជាង PT របស់ឪពុក/ម្ដាយ។",
  others_account_min_required: "[Others] ត្រូវការកំណត់ PT អប្បបរមារបស់គណនី។",
  others_account_pt_required: "[Others] ត្រូវការកំណត់ PT របស់គណនី។",
  others_exceeded_parent_commission: "[Others] ការកំណត់កម្រៃជើងសាររបស់គណនី ធំជាងរបស់ឪពុក/ម្ដាយ។",
  others_exceeded_parent_pt: "[Others] លើស PT របស់ឪពុក/ម្ដាយ។",
  others_max_bet_gt_max_per_match: "[Others] ភ្នាល់អតិបរមា ធំជាងអតិបរមាតាមការប្រកួត។",
  others_min_bet_gt_max_bet: "[Others] ភ្នាល់អប្បបរមា ធំជាងអតិបរមា។",
  others_parent_min_not_meet: "[Others] មិនស្មើនឹងអប្បបរមារបស់ឪពុក/ម្ដាយ។",
  others_parent_pt_not_exists: "[Others] ការកំណត់ PT របស់ឪពុក/ម្ដាយមិនមាន។",
  others_pt_setting_exists: "[Others] ការកំណត់ PT មានរួចហើយ។",
  others_upline_pt_required: "[Others] ត្រូវការកំណត់ PT របស់ Upline។",
  others_upline_remaining_gt_account_pt: "[Others] PT នៅសល់របស់ Upline ធំជាង PT របស់គណនី។",
  others_upline_remaining_required: "[Others] ត្រូវការកំណត់ PT នៅសល់របស់ Upline។",

  parent_hdp_packages_not_exists: "កញ្ចប់ HDP របស់ឪពុក/ម្ដាយមិនមាន។",
  parent_pt_not_exists: "PT របស់ឪពុក/ម្ដាយមិនមាន។",
  parent_setting_not_exists: "ការកំណត់ PT មិនមាន។",
  parlay_a_commission_required: "[Parlay A] ត្រូវការកំណត់កម្រៃជើងសារ។",
  parlay_a_exceeded_parent_commission: "[Parlay A] ការកំណត់កម្រៃជើងសាររបស់គណនី ធំជាងរបស់ឪពុក/ម្ដាយ។",
  parlay_a_required: "[Parlay A] ត្រូវការការកំណត់។",
  parlay_account_min_gt_pt: "[Parlay] ការកំណត់ PT អប្បបរមារបស់គណនី ធំជាង PT របស់ឪពុក/ម្ដាយ។",
  parlay_account_min_required: "[Parlay] ត្រូវការកំណត់ PT អប្បបរមារបស់គណនី។",
  parlay_account_pt_required: "[Parlay] ត្រូវការកំណត់ PT របស់គណនី។",
  parlay_b_commission_required: "[Parlay B] ត្រូវការកំណត់កម្រៃជើងសារ។",
  parlay_b_exceeded_parent_commission: "[Parlay B] ការកំណត់កម្រៃជើងសាររបស់គណនី ធំជាងរបស់ឪពុក/ម្ដាយ។",
  parlay_b_required: "[Parlay B] ត្រូវការការកំណត់។",
  parlay_exceeded_parent_pt: "[Parlay] លើស PT របស់ឪពុក/ម្ដាយ។",
  parlay_max_bet_gt_max_per_match: "[Parlay] ភ្នាល់អតិបរមា ធំជាងអតិបរមាតាមការប្រកួត។",
  parlay_min_bet_gt_max_bet: "[Parlay] ភ្នាល់អប្បបរមា ធំជាងអតិបរមា។",
  parlay_mmo_account_min_gt_pt: "[Parlay MMO] ការកំណត់ PT អប្បបរមារបស់គណនី ធំជាង PT របស់ឪពុក/ម្ដាយ។",
  parlay_mmo_account_min_required: "[Parlay MMO] ត្រូវការកំណត់ PT អប្បបរមារបស់គណនី។",
  parlay_mmo_account_pt_required: "[Parlay MMO] ត្រូវការកំណត់ PT របស់គណនី។",
  parlay_mmo_exceeded_parent_pt: "[Parlay MMO] លើស PT របស់ឪពុក/ម្ដាយ។",
  parlay_mmo_parent_min_not_meet: "[Parlay MMO] មិនស្មើនឹងអប្បបរមារបស់ឪពុក/ម្ដាយ។",
  parlay_mmo_parent_pt_not_exists: "[Parlay MMO] ការកំណត់ PT របស់ឪពុក/ម្ដាយមិនមាន។",
  parlay_mmo_pt_setting_exists: "[Parlay MMO] ការកំណត់ PT មានរួចហើយ។",
  parlay_mmo_upline_pt_required: "[Parlay MMO] ត្រូវការកំណត់ PT របស់ Upline។",
  parlay_mmo_upline_remaining_gt_account_pt: "[Parlay MMO] PT នៅសល់របស់ Upline ធំជាង PT របស់គណនី។",
  parlay_mmo_upline_remaining_required: "[Parlay MMO] ត្រូវការកំណត់ PT នៅសល់របស់ Upline។",
  parlay_parent_min_not_meet: "[Parlay] មិនស្មើនឹងអប្បបរមារបស់ឪពុក/ម្ដាយ។",
  parlay_parent_pt_not_exists: "[Parlay] ការកំណត់ PT របស់ឪពុក/ម្ដាយមិនមាន។",
  parlay_pt_setting_exists: "[Parlay] ការកំណត់ PT មានរួចហើយ។",
  parlay_pt_setting_not_exists: "[Parlay] ការកំណត់ PT មិនមាន។",
  parlay_upline_pt_required: "[Parlay] ត្រូវការកំណត់ PT របស់ Upline។",
  parlay_upline_remaining_gt_account_pt: "[Parlay] PT នៅសល់របស់ Upline ធំជាង PT របស់គណនី។",
  parlay_upline_remaining_required: "[Parlay] ត្រូវការកំណត់ PT នៅសល់របស់ Upline។",
  platform_code_required: "ត្រូវការកូដវេទិកា។",
  platform_name_required: "ត្រូវការឈ្មោះវេទិកា។",
  pt_setting_not_exists: "ការកំណត់ PT មិនមាន។",

  result_id_required: "ត្រូវការលេខសម្គាល់លទ្ធផល។",
  schedule_not_exists: "កាលវិភាគមិនមាន។",

  slots_commission_required: "[Slots] ត្រូវការកំណត់កម្រៃជើងសារ។",
  slots_commission_setting_exists: "[Slots] ការកំណត់កម្រៃជើងសារមានរួចហើយ។",
  slots_exceeded_parent_commission: "[Slots] ការកំណត់កម្រៃជើងសាររបស់គណនី ធំជាងរបស់ឪពុក/ម្ដាយ។",
  slots_parent_commission_not_exists: "[Slots] កម្រៃជើងសាររបស់ឪពុក/ម្ដាយមិនមាន។",

  soccer_1x2_account_min_gt_pt: "[1X2] ការកំណត់ PT អប្បបរមារបស់គណនី ធំជាង PT របស់ឪពុក/ម្ដាយ។",
  soccer_1x2_account_min_required: "[1X2] ត្រូវការកំណត់ PT អប្បបរមារបស់គណនី។",
  soccer_1x2_account_pt_required: "[1X2] ត្រូវការកំណត់ PT របស់គណនី។",
  soccer_1x2_parent_pt_not_exists: "[1X2] ការកំណត់ PT របស់ឪពុក/ម្ដាយមិនមាន។",
  soccer_1x2_pt_setting_not_exists: "[1X2] ការកំណត់ PT មិនមាន។",
  soccer_1x2_upline_pt_required: "[1X2] ត្រូវការកំណត់ PT របស់ Upline។",
  soccer_1x2_upline_remaining_gt_account_pt: "[1X2] PT នៅសល់របស់ Upline ធំជាង PT របស់គណនី។",
  soccer_1x2_upline_remaining_required: "[1X2] ត្រូវការកំណត់ PT នៅសល់របស់ Upline។",
  soccer_hdp_account_min_gt_pt: "[HDP] ការកំណត់ PT អប្បបរមារបស់គណនី ធំជាង PT របស់ឪពុក/ម្ដាយ។",
  soccer_hdp_account_min_required: "[HDP] ត្រូវការកំណត់ PT អប្បបរមារបស់គណនី។",
  soccer_hdp_account_pt_required: "[HDP] ត្រូវការកំណត់ PT របស់គណនី។",
  soccer_hdp_parent_pt_not_exists: "[HDP] ការកំណត់ PT របស់ឪពុក/ម្ដាយមិនមាន។",
  soccer_hdp_pt_setting_not_exists: "[HDP] ការកំណត់ PT មិនមាន។",
  soccer_hdp_upline_pt_required: "[HDP] ត្រូវការកំណត់ PT របស់ Upline។",
  soccer_hdp_upline_remaining_gt_account_pt: "[HDP] PT នៅសល់របស់ Upline ធំជាង PT របស់គណនី។",
  soccer_hdp_upline_remaining_required: "[HDP] ត្រូវការកំណត់ PT នៅសល់របស់ Upline។",
  soccer_max_bet_gt_max_per_match: "[Soccer] ភ្នាល់អតិបរមា ធំជាងអតិបរមាតាមការប្រកួត។",
  soccer_min_bet_gt_max_bet: "[Soccer] ភ្នាល់អប្បបរមា ធំជាងអតិបរមា។",
  soccer_others_account_min_gt_pt: "[Others] ការកំណត់ PT អប្បបរមារបស់គណនី ធំជាង PT របស់ឪពុក/ម្ដាយ។",
  soccer_others_account_min_required: "[Others] ត្រូវការកំណត់ PT អប្បបរមារបស់គណនី។",
  soccer_others_account_pt_required: "[Others] ត្រូវការកំណត់ PT របស់គណនី។",
  soccer_others_parent_pt_not_exists: "[Others] ការកំណត់ PT របស់ឪពុក/ម្ដាយមិនមាន។",
  soccer_others_pt_setting_not_exists: "[Others] ការកំណត់ PT មិនមាន។",
  soccer_others_upline_pt_required: "[Others] ត្រូវការកំណត់ PT របស់ Upline។",
  soccer_others_upline_remaining_gt_account_pt: "[Others] PT នៅសល់របស់ Upline ធំជាង PT របស់គណនី។",
  soccer_others_upline_remaining_required: "[Others] ត្រូវការកំណត់ PT នៅសល់របស់ Upline។",

  sportsbook_commission_setting_exists: "[Sportsbook] ការកំណត់កម្រៃជើងសារមានរួចហើយ។",
  sportsbook_mmo_commission_setting_exists: "[Sportsbook MMO] ការកំណត់កម្រៃជើងសារមានរួចហើយ។",
  sportsbook_mmo_parent_commission_not_exists: "[Sportsbook MMO] កម្រៃជើងសាររបស់ឪពុក/ម្ដាយមិនមាន។",
  sportsbook_parent_commission_not_exists: "[Sportsbook] កម្រៃជើងសាររបស់ឪពុក/ម្ដាយមិនមាន។",
  status_required: "ត្រូវការទិន្នន័យស្ថានភាព។",
  sub_not_exists: "គណនីរងមិនមាន។",

  target_profile_id_required: "ត្រូវការទិន្នន័យលេខសម្គាល់ប្រវត្តិគោលដៅ។",
  tennis_max_bet_gt_max_per_match: "[Tennis] ភ្នាល់អតិបរមា ធំជាងអតិបរមាតាមការប្រកួត។",
  tennis_min_bet_gt_max_bet: "[Tennis] ភ្នាល់អប្បបរមា ធំជាងភ្នាល់អតិបរមា។",
  tournament_commission_required: "ត្រូវការកំណត់កម្រៃជើងសារសម្រាប់ការប្រកួត។",
  tournament_commission_setting_exists: "ការកំណត់កម្រៃជើងសារសម្រាប់ការប្រកួតមានរួចហើយ។",
  tournament_exceeded_parent_commission: "កម្រៃជើងសាររបស់ឪពុក/ម្ដាយសម្រាប់ការប្រកួត លើស។",
  tournament_parent_commission_not_exists: "កម្រៃជើងសាររបស់ឪពុក/ម្ដាយសម្រាប់ការប្រកួតមិនមាន។",

  upline_pt_required: "ត្រូវការកំណត់ PT របស់ Upline។",
  upline_remaining_gt_account_pt: "PT នៅសល់របស់ Upline ធំជាង PT របស់គណនី។",
  upline_remaining_required: "ត្រូវការកំណត់ PT នៅសល់របស់ Upline។",
  wallet_not_exists: "កាបូបអេឡិចត្រូនិចមិនមាន។",
  working_date_required: "ត្រូវការទិន្នន័យកាលបរិច្ឆេទធ្វើការ។",
  password_expired_alert: "ពាក្យសម្ងាត់របស់អ្នកផុតកំណត់។ សូមកំណត់ពាក្យសម្ងាត់ថ្មី។",

  cs_min_bet_lt_soccer: "ភ្នាល់អប្បបរមា ទាបជាងភ្នាល់អប្បបរមាពីបាល់ទាត់។",
  cs_max_bet_gt_soccer: "ភ្នាល់អតិបរមា ធំជាងភ្នាល់អតិបរមាពីបាល់ទាត់។",
  cs_max_per_match_gt_soccer: "ភ្នាល់អតិបរមាតាមការប្រកួត ធំជាងការប្រកួតបាល់ទាត់។",
  cs_tooltips: "ការកំណត់ភ្នាល់ត្រឹមត្រូវ (Correct Score) ប៉ុណ្ណោះដែលគោរពតាមកំណត់របស់បាល់ទាត់។",

  contact_phone_format_error: "ទ្រង់ទ្រាយលេខទូរសព្ទមិនត្រឹមត្រូវ។",
  contact_email_format_error: "ទ្រង់ទ្រាយអ៊ីមែលមិនត្រឹមត្រូវ។",

  notice: "<div style='text-align: left;'><b><u>Notice: Update on Evolution Casino Betting Limits</u></b><br><br>Dear Valued Agent,<br><br>Please be informed that starting January 31, 2025, <b>Evolution Casino will no longer support company-imposed betting limits</b>. This adjustment means the platform will no longer restrict bet amounts, allowing for more flexibility in operations.<br><br>We appreciate your understanding and continued cooperation as we adapt to this change. Should you have any questions, feel free to contact our support team.<br><br>Thank you for your cooperation.</div>"

};
